import React, { useState } from "react";
import axios from "axios";


const useSmartTaskSchedulingTask = ({
    mainApi = '/pmis/smart_task_scheduling/task', 
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getSmartTaskSchedulingTaskData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                        values: data?.data
                    })
                }
                else {
                    onFinish({
                        axiosMode: "get",
                        status: "failure"
                    })
                }
                return {
                    ...data
                }
            });
    }
    const postSmartTaskSchedulingTaskData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish({
                        axiosMode: "post",
                        status: "failure"
                    })
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "success",
                        values: responseData
                    })
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "failure"
                })
            })

    }
    const patchSmartTaskSchedulingTaskData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure",
                            values: responseData
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch((error) => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure",
                        values: error?.response?.data
                    }
                )
            })
    }
    const deleteSmartTaskSchedulingTaskData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }

    // 以下為跟檔案有關的API
    const [responseData, setResponseData] = useState([])
    const exportSmartTaskSchedulingTaskData = (params) => {
        onBefore({
            axiosMode: "export"
        })
        axios
            .get('/pmis/smart_task_scheduling/task/export/excel', {
                responseType: 'blob',
                params: params,
            })
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '任務清單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "export",
                        status: "success"
                    }
                )
            })
    }
    const importSmartTaskSchedulingTaskData = (data) => {
        onBefore({
            axiosMode: "import"
        })
        const files = data.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', data?.choose_column);
        form_data.append('default_column', JSON.stringify(data?.columns));
        axios
            .post(`/pmis/smart_task_scheduling/task/import/read_sample`, form_data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                setResponseData(responseData.data)

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    const downloadSmartTaskSchedulingTaskData = () => {
        onBefore({
            axiosMode: "download_sample"
        })
        axios
            .get('/pmis/smart_task_scheduling/task/import/manual', {
                responseType: 'blob',
            })
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '題目匯入範例.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "download_sample",
                        status: "success"
                    }
                )
            })
    }
    const overSmartTaskSchedulingTaskData = (record) => {
        onBefore({
            axiosMode: "over"
        })
        axios
            .post('/pmis/smart_task_scheduling/task/import/over_data', record)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    return {
        NewsData: data,
        getSmartTaskSchedulingTaskData,
        postSmartTaskSchedulingTaskData,
        patchSmartTaskSchedulingTaskData,
        deleteSmartTaskSchedulingTaskData,
        exportSmartTaskSchedulingTaskData,
        importSmartTaskSchedulingTaskData,
        downloadSmartTaskSchedulingTaskData,
        overSmartTaskSchedulingTaskData,
    }
}
export { useSmartTaskSchedulingTask }
